import gsap from "gsap";

export default class QuickBuyPopUp {
  constructor(el) {
    this.button = el;
    this.popUp = document.querySelector("[data-js='quick-buy-mobile-pop-up']");
    this.close = document.querySelector("[data-js='close-quick-buy-mobile']");
    this.getContentHere = el.parentNode.parentNode.querySelector(
      "[data-js='quick-buy-mobile-get-content']",
    );
    this.empty = this.popUp.querySelector(
      "[data-js='quick-buy-mobile-innerHtml-here']",
    );
    this.clickableContent = this.popUp.querySelector(
      "[data-js='quick-buy-mobile-clickable-content']",
    );
    this.isOpen = false;
  }

  init() {
    this.clickOutside();

    if (this.button) {
      if (this.popUp) {
        // get the form from the card and append it to the pop up
        this.empty.innerHTML = this.getContentHere.innerHTML;

        // show additional content for mobile quick buy
        const form = this.empty.querySelector(
          "[data-js='form-quick-buy-size']",
        );
        form.querySelector("article").classList.remove("hidden");

        // import the js file for the form

        import("./quick-buy-sizes.js").then((r) => {
          const qbSizes = new r.default(form);
          qbSizes.init();
        });

        // import the js file for the size guide
        const productSizeGuide = this.empty.querySelector(
          "[data-js='product-size-guide']",
        );
        if (productSizeGuide) {
          import("../product/size-guide.js").then((r) => {
            const sizeGuide = new r.default();
            sizeGuide.init();
          });
        }

        this.animateOpenPopUp();
      }

      // close the pop up when clicking on the close button
      if (this.close) {
        this.close.addEventListener("click", () => {
          this.closePopUp();
        });
      }

      // close the pop up when adding to cart
      window.addEventListener("add-to-cart", () => {
        this.closePopUp();
      });
    }
  }

  animateOpenPopUp = () => {
    const tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: "power2.inOut",
      },
    });

    gsap.set(this.popUp, {
      autoAlpha: 0,
    });

    gsap.set(this.clickableContent, {
      yPercent: 100,
    });

    tl.to(this.popUp, {
      autoAlpha: 1,
      display: "flex",
    });

    tl.to(this.clickableContent, {
      yPercent: 0,
      onComplete: () => {
        document.body.style.overflow = "hidden";
        this.isOpen = true;
      },
    });
  };

  closePopUp = () => {
    const tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: "power2.inOut",
      },
    });

    tl.to(this.clickableContent, {
      yPercent: 100,
    });

    tl.to(this.popUp, {
      autoAlpha: 0,
      onComplete: () => {
        gsap.set(this.popUp, {
          display: "none",
        });
        document.body.style.overflow = "auto";
        this.isOpen = false;
      },
    });
  };

  clickOutside() {
    document.addEventListener("click", (event) => {
      if (
        this.isOpen &&
        !this.clickableContent.contains(event.target) &&
        !this.close.contains(event.target) &&
        event.target.dataset.js !== "size-guide__close"
      ) {
        // console.log('click outside')
        this.closePopUp();
      }
    });
  }
}
